// import React from "react";

// const SearchInput = ({
//   value,
//   onChange,
//   placeholder = "Search...",
//   icon: Icon,
//   wrapperClass = "",
//   inputClass = "",
// }) => {
//   return (
//     <div className={`relative w-full ${wrapperClass}`}>
//       {Icon && (
//         <Icon className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-highlight" />
//       )}

//       <input
//         type="text"
//         placeholder={placeholder}
//         value={value}
//         onChange={onChange}
//         className={`w-full pl-12 pr-4 py-3 rounded-lg text-gray-900
//           placeholder-gray-500 border border-gray-300
//           focus:outline-none text-sm placeholder:text-sm
//           ${inputClass}`}
//       />
//     </div>
//   );
// };

// export default SearchInput;

import React from "react";

const SearchInput = ({
  value,
  label,
  onChange,
  placeholder = "Search...",
  icon: Icon,
  onFocus,
  wrapperClass = "",
  inputClass = "",
  iconClass = "",
  isRequired = false,
}) => {
  return (
    <div className={`relative w-full ${wrapperClass}`}>
      {label && (
        <label className="text-sm md:font-semibold font-medium text-gray-700 mb-1">
          {label}
          {isRequired && (
            <span className="text-red-500 ml-1 font-bold">*</span>
          )}{" "}
        </label>
      )}
      {Icon && (
        <Icon
          className={`absolute md:left-4 left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-highlight ${iconClass}`}
        />
      )}

      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onFocus={onFocus}
        onChange={onChange}
        className={`w-full md:pl-12 pl-8 pr-4 py-3 rounded-lg text-gray-900 
          placeholder-gray-500 border-2 border-gray-300 
          focus:outline-none text-sm placeholder:text-sm 
          ${inputClass}`}
      />
    </div>
  );
};

export default SearchInput;
